module.exports = __webpack_public_path__ + "static/media/client-logo-16.6c848a32.jpg";